var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('v-alert',{attrs:{"outlined":"","text":"","type":"info"}},[_c('div',{staticClass:"title",staticStyle:{"white-space":"pre-line"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }